import { Grid, Typography } from "@mui/material";

const Quote = (props) => {
  return (
    <Grid pt="1rem" px={{ md: "2rem", lg: "5rem" }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          p: "1rem 3rem",
          borderRadius: "0.5rem",
          borderLeftWidth: "5px",
          borderLeftStyle: "solid",
          borderLeftColor: "secondary.main",
          borderRightWidth: "5px",
          borderRightStyle: "solid",
          borderRightColor: "secondary.main",
          lineHeight: "2.5rem",
        }}  
      >
        "{props.text}"
      </Typography>
    </Grid>
  )
}

export default Quote